var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.avatar)?_c('div',{staticClass:"SkeletonBox",style:({
      width: _vm.computedHeight,
      height: _vm.computedHeight,
      borderRadius: '50%',
    })}):_c('div',{staticClass:"SkeletonBox",class:{ rounded: _vm.rounded, pill: _vm.pill },style:({ height: _vm.height, width: _vm.computedWidth })})])
}
var staticRenderFns = []

export { render, staticRenderFns }